let IS_PROD = true;
const server = IS_PROD
  ? "https://zoomvideocallbackend.onrender.com"
  : "http://localhost:8000";

export default server;
